import React from 'react';
import InternalLink from '../../../../atoms/InternalLink';
import { ObjectPropsPropType } from '../../../../services/proptypes';
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../../analytics/components/Event';
import { addSlashToPath } from '../../../navigation/services/slugs';
import './BlogPostLink.css';
var defaultProps = {
  children: null,
  content: null,
  blogRootSlug: '/blog/'
};
export default function BlogPostLink(_ref) {
  var children = _ref.children,
    content = _ref.content,
    slug = _ref.slug,
    title = _ref.title,
    blogRootSlug = _ref.blogRootSlug;
  var slugPath = addSlashToPath([blogRootSlug, slug]);
  return /*#__PURE__*/React.createElement(InternalLink, {
    to: slugPath,
    event: {
      category: EVENT_CATEGORIES.BLOG_EVENT_CATEGORY,
      action: EVENT_ACTIONS.BLOG_VIEW_POST_EVENT_ACTION,
      label: title
    },
    className: "blog-post-link"
  }, children || content);
}
BlogPostLink.defaultProps = defaultProps;